import { useEffect, useState } from "react";

function useMediaQuery(query: string): boolean {
  // Always start with false to match server-side rendering
  const [matches, setMatches] = useState<boolean>(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Mark as mounted and evaluate media query
    setMounted(true);

    if (typeof window !== "undefined") {
      const matchMedia = window.matchMedia(query);

      setMatches(matchMedia.matches);

      const handleChange = () => setMatches(matchMedia.matches);

      if (matchMedia.addEventListener) {
        matchMedia.addEventListener("change", handleChange);
        return () => {
          matchMedia.removeEventListener("change", handleChange);
        };
      } else {
        // Fallback to onchange for maximum compatibility
        matchMedia.onchange = handleChange;
        return () => {
          matchMedia.onchange = null;
        };
      }
    }
  }, [query]);

  // Return false during SSR and before hydration
  return mounted ? matches : false;
}

export default useMediaQuery;
